import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { CheckCircle, Loader2, PartyPopper } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function CheckoutSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    // Simple verification - just wait a moment for webhook to process
    const timer = setTimeout(() => {
      setStatus("success");
    }, 2000);

    return () => clearTimeout(timer);
  }, [sessionId]);

  if (status === "loading") {
    return (
      <div className="min-h-screen bg-background">
        <Navbar />
        <div className="flex items-center justify-center pt-8">
        <Card className="w-full max-w-md">
          <CardContent className="p-8 text-center">
          <Loader2 className="h-12 w-12 animate-spin mx-auto text-primary" />
            <p className="mt-4 text-muted-foreground">Processing your subscription...</p>
          </CardContent>
        </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="flex items-center justify-center p-4 pt-8">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 relative">
            <CheckCircle className="h-16 w-16 text-green-500" />
            <PartyPopper className="h-8 w-8 text-primary absolute -top-2 -right-2 animate-bounce" />
          </div>
          <CardTitle className="text-2xl">Welcome to iSPAI!</CardTitle>
          <CardDescription>
            Your subscription is now active
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <h3 className="font-medium">What's next?</h3>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Your Owned Gibs have been added to your balance</li>
              <li>• Start creating Knowledge Bases</li>
              <li>• Join or create Sprints with your team</li>
              <li>• Explore the marketplace</li>
            </ul>
          </div>

          <div className="flex flex-col gap-2">
            <Button onClick={() => navigate("/creators")} className="w-full">
              Go to Dashboard
            </Button>
            <Button variant="outline" onClick={() => navigate("/marketplace")} className="w-full">
              Explore Marketplace
            </Button>
          </div>
        </CardContent>
      </Card>
      </div>
    </div>
  );
}
